export const mainNavItems = [
  {
    name: 'Dashboard',
    icon: 'fas fa-chart-line',
    isToggle: false,
    children: [
      {
        name: 'New dashboard',
        url: '/dashboards/create',
        icon: 'fas fa-plus-square'
      }
    ]
  },
  {
    name: 'Assets',
    url: '/assets',
    icon: 'fas fa-map-marked'
  },
  {
    name: 'Devices',
    url: '/devices',
    icon: 'fas fa-microchip'
  },
  {
    name: 'Alerts history',
    url: '/alerts/',
    icon: 'fas fa-bell',
    badge: 'pendingAlerts'
  },
  {
    name: 'Administration',
    icon: 'fas fa-unlock-alt',
    isToggle: false,
    children: [
      {
        name: 'Users',
        url: '/admin/users',
        icon: 'fas fa-users-cog'
      },
      {
        name: 'Alerts configuration',
        url: '/admin/alert-rules/',
        icon: 'fas fa-filter'
      }
    ]
  }
];

export const userSettingsNavItems = [
  {
    name: 'Profile',
    url: '/me/profile',
    icon: 'fas fa-user'
  }
];

export const getNavItemsFromRoute = (
  path: string,
  isPlatformAdminMenuShowed: boolean
) => {
  if (path.substr(0, 4) === '/me/') {
    return userSettingsNavItems;
  }

  if (isPlatformAdminMenuShowed) {
    return [
      ...mainNavItems,
      {
        name: 'Platform management',
        icon: 'fas fa-tools',
        isToggle: false,
        children: [
          {
            name: 'Tenants',
            url: '/platform-management/tenants',
            icon: 'fas fa-database'
          }
        ]
      }
    ];
  }

  return mainNavItems;
};
